import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { WithdrawalApprovalsTable } from "WithdrawalApprovals/Components/WithdrawalApprovalsTable";

export const WithdrawalApprovalsPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      preTitle={t(Resources.Common.Admin)}
      title={t(Resources.Common.WithdrawalApprovals)}
    >
      <Stack spacing={Spacing.L}>
        <WithdrawalApprovalsTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
